<script setup>
const props = defineProps({
  pid: {
    type: String,
    default: ''
  }
})

const route = useRoute()
const trueId = computed(() => makeTrueId(props.pid))

const { data: isInvalidUrl } = await useFetch('/api/river/url', { query: { path: route.params.river || 'others', id: trueId.value } })
if (isInvalidUrl.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Query Parameter'
  })
}

const { data: pointInfo } = await useAsyncData(
  `pointInfo-${trueId.value}`,
  () => $fetch('/api/river/point', { query: { pid: trueId.value } }),
  { watch: [trueId] }
)
const pointType = computed(() => {
  if (!pointInfo.value) {
    return 'obs'
  } else if (!pointInfo.value.CameraID) {
    return 'obs'
  } else if (pointInfo.value.CameraID === pointInfo.value.ID) {
    return 'cam'
  } else {
    return 'obscam'
  }
})
const componentName = computed(() => {
  if (pointType.value === 'obs') return resolveComponent('PagePointObs')
  if (pointType.value === 'obscam') return resolveComponent('PagePointObscam')
  if (pointType.value === 'cam') return resolveComponent('PagePointCam')
  return null
})

const { data: riverList } = await useRiverList()
const riverInfo = computed(() => riverList.value?.find((r) => r.code === route.params.river))
</script>

<template>
  <component
    :is="componentName"
    v-if="componentName"
    :point-info="pointInfo"
    :river-name="riverInfo?.name"
  />
</template>

<style lang="scss" scoped>
</style>
